import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import { Tooltip } from "@mui/material";

const initialColumns = [
    {
        width: 80,
        field: 'idAutorizacionPrecioMasivo',
        headerName: '#'
    },
    {
        width: 140,
        field: 'delegacion',
        headerName: 'Delegacion'
    },
    {
        width: 100,
        field: 'fecha',
        headerName: 'Fecha'
    },
    {
        width: 200,
        field: 'solicitante',
        headerName: 'solicitante'
    },
    {
        width: 80,
        field: 'idEvaluacion',
        headerName: 'Contrato'
    },
    {
        width: 200,
        field: 'paciente',
        headerName: 'Paciente'
    },
    {
        width: 200,
        field: 'planCuidado',
        headerName: 'Plan'
    },
    {
        width: 100,
        field: 'codigoPlan',
        headerName: 'Código'
    },
    {
        width: 200,
        field: 'financiador',
        headerName: 'Financiador'
    },
    {
        width: 150,
        field: 'periodo',
        headerName: 'Periodo'
    },
    {
        width: 100,
        field: 'precioActual',
        headerName: 'Precio Actual',
        valueGetter: (precioActual) => '$' + precioActual?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    {
        width: 100,
        field: 'precioControl',
        headerName: 'Precio Control',
        valueGetter: (precioControl) => {
            return '$' + precioControl?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    },
    {
        width: 100,
        field: 'precioSAP',
        headerName: 'Precio SAP',
        valueGetter: (precioSAP) => {
            return '$' + precioSAP?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    },
    {
        width: 100,
        field: 'precioACambiar',
        headerName: 'Precio a cambiar',
        valueGetter: (precioACambiar) => {
            return '$' + precioACambiar?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
    },
    {
        width: 80,
        field:'viable',
        headerName: 'Viable',
        renderCell: ({ row }) => {
            const { viable } = row;
            const icon = viable
                ? <CheckIcon className='icon-grid' />
                : <ClearIcon className='icon-grid' />;
            return <Tooltip title={viable ? 'Si' : 'No'}>{icon}</Tooltip>
        }
    }
];

export const useGetColumns = () => {
    
    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), []);

    return columns;
}


